export default {"src":"/_next/static/image/public/images/flags/flag_507.9d4798c865f32466ef8bf92f222b8328.svg","height":16,"width":24};